import { createContext } from 'react';

/**
 * The mutually-exclusive sliding panels on the Find & Fix / SAVI map. This value is the
 * AUTHORITATIVE open-state for these panels — MapView renders each from `activePanel`
 * directly, so opening one panel closes the others structurally rather than by hand-synced
 * per-panel state. The POI details panel is not listed: it derives from the map-interaction
 * selection, and selecting a POI closes whichever panel is open via `setActivePanel(null)`.
 */
export type ExclusivePanel = 'layers' | 'filters' | 'stats' | 'download' | 'mapKey';

export interface ExclusivePanelContextValue {
    /** The panel currently open, or null when none is open. */
    activePanel: ExclusivePanel | null;
    /** Open the given panel (closing any other), or close all when passed null. */
    setActivePanel: (panel: ExclusivePanel | null) => void;
}

export const ExclusivePanelContext = createContext<ExclusivePanelContextValue | null>(null);
